// Contextual help distilled from the reviewed official support content. No customer data.
window.IKARAO_HELP = [
  {
    "id": "activation",
    "flow": "karafun",
    "branch": "offer",
    "title": "Find your KaraFun activation step",
    "body": "Choose whether you are registering, signing in, hearing previews or missing an included offer. If you need help, have your device details and the offer from your purchase ready. Do not send passwords.",
    "cta": {
      "label": "Choose my activation step",
      "url": "troubleshooting.html?flow=karafun"
    },
    "sourceIds": [
      "FAQ-01"
    ],
    "keywords": "How to activate KaraFun?"
  },
  {
    "id": "x1-guide",
    "flow": "setup",
    "branch": "first",
    "title": "Start with your Break X1 guide",
    "body": "For Break X1, open the matching manual for setup and controls. A video can help, but confirm that the featured product matches yours.",
    "cta": {
      "label": "Open Break X1 manual",
      "url": "manuals.html#break-x1"
    },
    "sourceIds": [
      "FAQ-02"
    ],
    "keywords": "Break X1 Video Guide"
  },
  {
    "id": "x2-guide",
    "flow": "setup",
    "branch": "first",
    "title": "Start with your Break X2 guide",
    "body": "For Break X2, open the matching manual for setup and controls. A video can help, but confirm that the featured product matches yours.",
    "cta": {
      "label": "Open Break X2 manual",
      "url": "manuals.html#break-x2"
    },
    "sourceIds": [
      "FAQ-03"
    ],
    "keywords": "Break X2 Video Guide"
  },
  {
    "id": "version",
    "flow": "apps",
    "branch": "update",
    "title": "Find your software version",
    "body": "Use the About or version section documented for your model to identify the installed software. Record the version you actually see; do not assume every IKARAO product runs the same Android version.",
    "cta": {
      "label": "Find my model manual",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-04"
    ],
    "keywords": "Which Android version does this machine use?"
  },
  {
    "id": "mic-support",
    "flow": "sound",
    "branch": "voice",
    "title": "Check microphone compatibility",
    "body": "Identify your machine and microphones before adding another microphone. Check the matching manual for supported inputs and simultaneous use. Phone Bluetooth audio and wireless microphone connections are different tasks.",
    "cta": {
      "label": "Check model resources",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-05",
      "FAQ-11"
    ],
    "keywords": "How many microphones can be connected at the same time? What about Bluetooth microphones? How many microphones does your product support?"
  },
  {
    "id": "mic-charge",
    "flow": "sound",
    "branch": "charging",
    "title": "Charge the supplied microphones",
    "body": "Use the charging method documented for your machine and microphone model. If your model uses charging slots, check seating against its manual. Compare the indicator with that same manual; if charging remains unclear, share the microphone and dock indicators.",
    "cta": {
      "label": "Ask about microphone charging",
      "url": "contact.html#request"
    },
    "sourceIds": [
      "FAQ-06",
      "FAQ-21"
    ],
    "keywords": "Does the microphone use batteries? How do you charge it? How do I know if the mic is fully charged?"
  },
  {
    "id": "wifi",
    "flow": "apps",
    "branch": "wifi",
    "title": "Connect the device to Wi-Fi",
    "body": "On a compatible screen-equipped model, open the Wi-Fi settings shown in its manual, choose your network and enter the password on the device. If connection fails, record the message. Never send your network password to Support.",
    "cta": {
      "label": "App download help",
      "url": "troubleshooting.html?flow=apps&branch=download"
    },
    "sourceIds": [
      "FAQ-07"
    ],
    "keywords": "Can I connect to Wi-Fi? How to connect?"
  },
  {
    "id": "hdmi",
    "flow": "setup",
    "branch": "tv",
    "title": "Connect to a television",
    "body": "For a model with a documented HDMI output, connect it to a TV HDMI input and select that input on the TV. If there is no picture, record the product model, port and TV input. This is a cable connection, not a promise of wireless casting.",
    "cta": {
      "label": "Check connection instructions",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-08"
    ],
    "keywords": "Can you connect to a TV for screen casting?"
  },
  {
    "id": "compare",
    "flow": "setup",
    "branch": "choose",
    "title": "Choose the right product resources",
    "body": "Compare the exact product pages for screen, size, output and ports. For a product you already own, identify it from the label or purchase record before following setup steps.",
    "cta": {
      "label": "Identify my model",
      "url": "device-info.html"
    },
    "sourceIds": [
      "FAQ-09"
    ],
    "keywords": "What are the differences between Break X1 and Break X2?"
  },
  {
    "id": "accessory",
    "flow": "setup",
    "branch": "accessories",
    "title": "Find a compatible accessory",
    "body": "Match bags, stands and replacement microphones to your exact product. Confirm fit, connector and any load limits before purchase; a similar appearance or socket size alone does not establish compatibility.",
    "cta": {
      "label": "Ask about compatibility",
      "url": "contact.html"
    },
    "sourceIds": [
      "FAQ-10",
      "FAQ-37"
    ],
    "keywords": "What accessories can I buy? Are your stands a universal size? What are the dimensions?"
  },
  {
    "id": "updates",
    "flow": "apps",
    "branch": "update",
    "title": "Check for available updates",
    "body": "Check the update status on your device using its model guide. If an issue remains and no update appears, share the displayed version with Support. This page cannot request or schedule a remote update.",
    "cta": {
      "label": "Continue update checks",
      "url": "troubleshooting.html?flow=apps&branch=update"
    },
    "sourceIds": [
      "FAQ-12"
    ],
    "keywords": "Will your product's software be continuously updated?"
  },
  {
    "id": "box",
    "flow": "setup",
    "branch": "first",
    "title": "Check what came with your product",
    "body": "Compare the contents with the supplied-accessories list for your exact model and order. If something is missing, note which item and check whether another parcel is still due.",
    "cta": {
      "label": "Missing or damaged delivery",
      "url": "troubleshooting.html?flow=orders&branch=damage"
    },
    "sourceIds": [
      "FAQ-13"
    ],
    "keywords": "What's in the box?"
  },
  {
    "id": "overview",
    "flow": "setup",
    "branch": "first",
    "title": "Understand your product before starting",
    "body": "Identify your product's screen, microphone storage and playback controls in its guide. Product layouts and features differ. Start with the first-use instructions for your own model.",
    "cta": {
      "label": "Open first-use help",
      "url": "troubleshooting.html?flow=setup&branch=first"
    },
    "sourceIds": [
      "FAQ-14"
    ],
    "keywords": "What makes your product different from others?"
  },
  {
    "id": "simple-start",
    "flow": "setup",
    "branch": "first",
    "title": "Start one step at a time",
    "body": "Use the matching quick-start guide, then try one playback task at a time. A helper can follow the same guide with you. If a step is unclear, tell Support which screen or control you reached.",
    "cta": {
      "label": "Watch a setup guide",
      "url": "user-guide.html"
    },
    "sourceIds": [
      "FAQ-15"
    ],
    "keywords": "Is it easy to use? I want to buy it for my parents."
  },
  {
    "id": "screen",
    "flow": "setup",
    "branch": "first",
    "title": "Check whether your model has a screen",
    "body": "Use your product guide to identify its controls and any built-in screen. Screen-based app instructions do not apply to every IKARAO product. App access or subscriptions may require separate steps.",
    "cta": {
      "label": "Choose product resources",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-16"
    ],
    "keywords": "Does the machine include a tablet?"
  },
  {
    "id": "portable",
    "flow": "power",
    "branch": "unplugged",
    "title": "Plan portable or plugged-in use",
    "body": "Check your exact model's battery and charging instructions before portable use or use while charging. Use the specified power equipment. If it turns off without external power, record that behaviour rather than assuming the battery is faulty.",
    "cta": {
      "label": "Battery-use help",
      "url": "troubleshooting.html?flow=power&branch=unplugged"
    },
    "sourceIds": [
      "FAQ-17",
      "FAQ-18"
    ],
    "keywords": "Does it have a built-in battery? I want to use it outdoors. Can I use it while charging?"
  },
  {
    "id": "phone",
    "flow": "sound",
    "branch": "phone",
    "title": "Play audio from a phone",
    "body": "If your model supports phone Bluetooth audio, use its documented pairing instructions to play audio from your iPhone or another compatible phone. This does not mean phone-screen mirroring or arbitrary Bluetooth microphones are supported.",
    "cta": {
      "label": "Open model instructions",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-19"
    ],
    "keywords": "I use an Apple phone, can your Android system work with it?"
  },
  {
    "id": "outdoor",
    "flow": "setup",
    "branch": "outdoor",
    "title": "Check outdoor-use limits",
    "body": "Check the environmental-use instructions for your exact model before taking it outdoors. Do not interpret a water-resistance rating as waterproofing or permission to expose open ports to water.",
    "cta": {
      "label": "Read model guidance",
      "url": "manuals.html"
    },
    "sourceIds": [
      "FAQ-20"
    ],
    "keywords": "What is the waterproof rating of IKARAO product?"
  },
  {
    "id": "destination",
    "flow": "orders",
    "branch": "delivery",
    "title": "Check delivery availability",
    "body": "For a new order, check delivery availability for your destination at checkout. For an existing order, use its confirmation and tracking details. Contact Support if the destination or delivery arrangement is unclear.",
    "cta": {
      "label": "Track an existing order",
      "url": "track-order.html"
    },
    "sourceIds": [
      "FAQ-22"
    ],
    "keywords": "Where do you ship?"
  },
  {
    "id": "charges",
    "flow": "orders",
    "branch": "costs",
    "title": "Check shipping and import charges",
    "body": "Review the charges shown for your destination at checkout and in your order confirmation. If tax, duty or shipping charges are unclear, ask Support before assuming they are included or refundable.",
    "cta": {
      "label": "Ask about order charges",
      "url": "contact.html"
    },
    "sourceIds": [
      "FAQ-23",
      "FAQ-26"
    ],
    "keywords": "Will my package be charged customs duties and taxes? How are shipping costs calculated?"
  },
  {
    "id": "delivery",
    "flow": "orders",
    "branch": "delivery",
    "title": "Find the delivery estimate",
    "body": "Use your shipment confirmation and carrier tracking for the estimate that applies to your parcel. Delivery can vary by destination and service. If the estimate has passed or no tracking is available, contact Support with the order reference.",
    "cta": {
      "label": "Track my shipment",
      "url": "track-order.html"
    },
    "sourceIds": [
      "FAQ-24"
    ],
    "keywords": "How long will it take for my order to arrive?"
  },
  {
    "id": "address",
    "flow": "orders",
    "branch": "address",
    "title": "An address needs correcting",
    "body": "Contact Support promptly with the order reference and explain whether the order has shipped. Address changes may not be possible after dispatch. Do not assume a correction or redelivery has been arranged until confirmed.",
    "cta": {
      "label": "Contact Support",
      "url": "contact.html"
    },
    "sourceIds": [
      "FAQ-25",
      "FAQ-28"
    ],
    "keywords": "Can I change the delivery address after shipment? What happens if I gave the wrong delivery address?"
  },
  {
    "id": "damage",
    "flow": "orders",
    "branch": "damage",
    "title": "An item is damaged, wrong or missing",
    "body": "Compare the received items with the order and any remaining parcels. Keep packaging and take clear photos of the affected item and package. Explain what was expected and what arrived so Support can review it.",
    "cta": {
      "label": "Prepare support details",
      "url": "contact.html#request"
    },
    "sourceIds": [
      "FAQ-27"
    ],
    "keywords": "What should I do if I find shipping damage or wrong items?"
  },
  {
    "id": "tracking",
    "flow": "orders",
    "branch": "tracking",
    "title": "Find a tracking number",
    "body": "Check your shipping confirmation for the carrier and tracking number. Use shipment tracking for delivery updates. An order reference is not always the carrier tracking number.",
    "cta": {
      "label": "Open Track Order",
      "url": "track-order.html"
    },
    "sourceIds": [
      "FAQ-29"
    ],
    "keywords": "What is my tracking number? How can I track my order?"
  },
  {
    "id": "carrier",
    "flow": "orders",
    "branch": "tracking",
    "title": "Identify the carrier",
    "body": "Use the carrier named in your shipping confirmation or tracking result. Carrier arrangements can differ between orders; do not select one solely from a general carrier list.",
    "cta": {
      "label": "Track a shipment",
      "url": "track-order.html"
    },
    "sourceIds": [
      "FAQ-30"
    ],
    "keywords": "Which logistics companies do we cooperate with?"
  },
  {
    "id": "split",
    "flow": "orders",
    "branch": "delivery",
    "title": "Check for separate parcels",
    "body": "Items and accessories may arrive in separate parcels. Compare the shipping notices and tracking numbers before reporting an item missing. If no remaining parcel explains it, tell Support which item is absent.",
    "cta": {
      "label": "Report a missing item",
      "url": "troubleshooting.html?flow=orders&branch=damage"
    },
    "sourceIds": [
      "FAQ-31"
    ],
    "keywords": "Will my accessories be delivered along with the product?"
  },
  {
    "id": "warranty",
    "flow": "service",
    "branch": "warranty",
    "title": "Check warranty and extension options",
    "body": "Have the model, purchase date and seller ready when asking about coverage. Review the official warranty-extension page for the current registration terms. Missing purchase details do not stop you from asking Support for help.",
    "cta": {
      "label": "View extension information",
      "url": "https://ikarao.com/pages/warranty-extension"
    },
    "sourceIds": [
      "FAQ-32",
      "FAQ-33"
    ],
    "keywords": "How long is the warranty period? Is there an additional extended warranty service?"
  },
  {
    "id": "problem",
    "flow": "service",
    "branch": "request",
    "title": "Get help with a product problem",
    "body": "Choose your symptom on the Support home page or prepare a support request. Include only the checks you actually tried and the result. You can contact the team without completing every check.",
    "cta": {
      "label": "Prepare a request",
      "url": "contact.html#request"
    },
    "sourceIds": [
      "FAQ-34"
    ],
    "keywords": "What should I do if there is a problem with the product?"
  },
  {
    "id": "contact",
    "flow": "service",
    "branch": "request",
    "title": "Contact the Support team",
    "body": "Email support@ikarao.com for help. If you are already in touch, reply in the existing email conversation so the team can follow the details. Do not include passwords or verification codes.",
    "cta": {
      "label": "Contact Support",
      "url": "contact.html"
    },
    "sourceIds": [
      "FAQ-35"
    ],
    "keywords": "What are the contact methods?"
  },
  {
    "id": "exchange",
    "flow": "service",
    "branch": "exchange",
    "title": "Ask about a replacement or exchange",
    "body": "Contact Support with the product, issue and purchase information you have. The team needs to review the appropriate route before an exchange can be confirmed. This prototype does not submit or approve an exchange.",
    "cta": {
      "label": "Prepare support details",
      "url": "contact.html#request"
    },
    "sourceIds": [
      "FAQ-36"
    ],
    "keywords": "How can I apply for an exchange?"
  },
  {
    "id": "charger",
    "flow": "power",
    "branch": "replacement",
    "title": "Replace a lost or damaged power supply",
    "body": "Identify the exact product and the original power-supply specifications in its guide. Confirm compatibility before buying a replacement. If the label or required rating is unclear, ask Support rather than choosing by wattage alone.",
    "cta": {
      "label": "Ask about a replacement",
      "url": "contact.html"
    },
    "sourceIds": [
      "FAQ-38"
    ],
    "keywords": "If my charger is broken or lost, what should I do?"
  }
];
